/**
 * Maps EditableCell fieldKey to change_operations.column_id (server catalog).
 * Keep in sync with server/src/tracking/projectFieldCatalog.ts
 */
const FIELD_KEY_TO_COLUMN_ID: Record<string, string> = {
  author: 'authors',
  producer: 'producers',
  techeditor: 'techeditors',
  corrector: 'correctors',
  studio: 'contractors',
  department: 'edition',
};

/**
 * Resolves API columnId for history filter.
 * - combo: returns undefined (use columnIds filter on client)
 * - known aliases: mapped catalog id
 * - otherwise: fieldKey as-is when it matches catalog column ids
 */
export function resolveHistoryColumnId(fieldKey: string): string | undefined {
  if (fieldKey === 'combo') {
    return undefined;
  }
  if (FIELD_KEY_TO_COLUMN_ID[fieldKey]) {
    return FIELD_KEY_TO_COLUMN_ID[fieldKey];
  }
  return fieldKey;
}

/** Column ids included in a combo cell (for client-side history filter). */
export function resolveHistoryColumnIdsForCombo(
  fieldKey: string,
  comboChildIds?: string[]
): string[] | undefined {
  if (fieldKey !== 'combo' || !comboChildIds?.length) {
    return undefined;
  }
  return comboChildIds.map((id) => FIELD_KEY_TO_COLUMN_ID[id] ?? id);
}
